import { render, staticRenderFns } from "./priceIndex.vue?vue&type=template&id=ebe7705a&scoped=true&"
import script from "./priceIndex.vue?vue&type=script&lang=js&"
export * from "./priceIndex.vue?vue&type=script&lang=js&"
import style0 from "./priceIndex.vue?vue&type=style&index=0&id=ebe7705a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe7705a",
  null
  
)

export default component.exports